import { Drawer, Layout } from 'antd'
import React, { useState } from 'react'
import Navbar from './Navbar';
import Sidemenu from './Sidemenu';
import "../Styles/Container.css"
import commonLib from '../control/commonLib';
import SideMenue2 from "../components/SideMenue2"
import DashboardData from "./DashBoard/DashboardData"

const { Sider, Content } = Layout;

function Container({ children,subtinentDetails,setSubtinentDetails }) {
    const stateObj = JSON.parse(commonLib.getSessionStoarge("stateObj"))
    const roleId = stateObj?.roleId
    console.log("vv",roleId)
    const [closeAllModal,setCloseModal]=useState(false)

    return (

        <Layout>

            <div className="parentDiv">
                <div className="headerDiv">
                    <Navbar className="" roleId={roleId} setSubtinentDetails={setSubtinentDetails}>
                        <Sidemenu />
                    </Navbar>
                </div>
                <div className="bodyDiv" style={{     display: "flex",     height: "calc(100vh - 4.6rem)",     overflow:"hidden" }} >
                    {roleId != 6 && (
                    <div style={{maxwidth: "200px"}}>
                        <SideMenue2 closeAllModal={closeAllModal} setCloseModal={setCloseModal}/>
                    </div>
                    )}
                    {/* <div style={{ flex: 1,  overflow: "auto" }} >
                        <DashboardData closeAllModal={closeAllModal} setCloseModal={setCloseModal}/>
                    </div> */}
                     <Content className='rigth-container bg-white' style={{paddingLeft:"20px",paddingRight:"20px"}} >
                    <div className="site-layout-background" style={{minHeight: 600, }}>
                        {children}
                    </div>
                </Content>
                    </div>
            </div>




        {/* <Layout> Old code
           {(roleId !== "6")?
            <Sider breakpoint='lg'
                    className='widthSeborder-0 border-right'
                    theme='light'
                    width={300}
                    collapsedWidth={0}
                    trigger={null}
                ><Sidemenu />
                </Sider>:""}

                <Content className='rigth-container bg-white' >
                    <div className="site-layout-background" style={{ paddingRight:"0px", paddingLeft:"5px", minHeight: 600, }}>
                        {children}
                    </div>
                </Content>
            </Layout> */}
        </Layout>
    )
}

export default Container